import React from 'react';

type ModalFooterType = {
    children: React.ReactNode;
};

const getActionCount = (children: React.ReactNode): number => {
    return React.Children.toArray(children).reduce<number>((count, child) => {
        if (React.isValidElement(child) && child.type === React.Fragment) {
            return count + getActionCount(child.props.children);
        }

        return count + 1;
    }, 0);
};

export const ModalFooter: React.FC<ModalFooterType> = ({ children }: ModalFooterType) => {
    const actionCount = getActionCount(children);

    return children ? (
        <div
            className={`flex items-center gap-small px-small pb-small pt-xsmall md:px-[3.2rem] md:pb-[3.2rem] md:pt-[1.6rem] ${
                actionCount === 1 ? 'justify-end' : 'justify-between'
            }`}
        >
            {children}
        </div>
    ) : null;
};
